import React, { useEffect, useRef, useState } from "react";
import qrIcon from "../../images/qr_icon_01.png";
import modalIcon01 from "../../images/modal-icon_01.png";
import modalIcon02 from "../../images/modal-icon_02.png";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../PageHeader";

export default function AddFireOnListComponent() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    setFormDataProperty("serialNumber", "");
    setFormDataProperty("dei", "");

    // React Native로부터 QR 결과 메시지를 받기 위한 이벤트 리스너 추가
    const handleMessage = (event) => {
      try {
        const qrData = event.detail;
        handleQRResult(qrData);
      } catch (error) {
        // 일반 문자열 메시지인 경우
        if (event.data && typeof event.data === "string") {
          handleQRResult(event.data);
        }
      }
    };

    // React Native WebView 메시지 이벤트 리스너
    if (window.ReactNativeWebView) {
      document.addEventListener("qr_result", handleMessage);
      window.addEventListener("qr_result", handleMessage);
    }

    return () => {
      if (window.ReactNativeWebView) {
        document.removeEventListener("qr_result", handleMessage);
        window.removeEventListener("qr_result", handleMessage);
      }
    };
  }, []);
  const handleQRResult = (qrData) => {
    try {
      // QR 코드 데이터를 파싱하여 serialNumber와 dei 추출
      const data = JSON.parse(qrData);
      if (data.serialNumber && data.dei) {
        setFormDataProperty("serialNumber", data.serialNumber);
        setFormDataProperty("dei", data.dei);
      }
    } catch (error) {
      // JSON 파싱 실패 시 문자열 그대로 사용
      console.log("QR 결과:", qrData);
    }
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { status, data } = await fireonApi.getFireFightingObject(
          formData.serialNumber,
          formData.dei
        );
        if (status === true) {
          setTarget(data);

          if (data.isCreated) {
            const id = data.id;
            apiWrapper(async () => {
              const { status, data } = await fireonApi.joinFireFightingObject(
                id
              );
              if (status === true) {
                setIsCompleted(true);
              } else {
                alert(`${data}`);
              }
            });
          } else {
            alert(
              `등록된 대상물 정보가 없습니다.\r\n대상물을 먼저 등록해주세요.`
            );
          }
        } else {
          setIsNotFound(true);
        }
      });
    }
  };

  const checkValid = () => {
    return true;
  };

  const handleStartScan = () => {
    // React Native로 QR 스캔 시작 메시지 전송
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("open_qr");
    }
  };

  return (
    <>
      {
        <section class="mbSection">
          <PageHeader
            isBlack={false}
            title="소방대상물 추가"
            isUseMenu={false}
          />
          <form onSubmit={handleSubmit}>
            <div class="container pb-90">
              <>
                <div class="qrWrap">
                  <p class="wrap-title">QR 스캔</p>
                  <p class="wrap-sub">
                    QR이 없으실 경우 아래 화재 수신기 일련번호와 <br />
                    화재수신기 DEI코드를 직접 작성해주세요.
                  </p>
                  <div class="qr-add-wrap">
                    {
                      <>
                        <img src={qrIcon} alt="QR 등록하기" class="qr-icon" />
                        <button
                          type="button"
                          class="btn btn-QR"
                          onClick={handleStartScan}
                        >
                          QR 등록하기
                        </button>
                      </>
                    }
                  </div>
                </div>
                <div class="input-wrap input-join-wrap">
                  {formData && (
                    <>
                      <div class="input-item">
                        <p class="input-title">화재수신기 일련번호</p>
                        <div class="input-inner-wrap">
                          <input
                            class="defaultInput"
                            type="text"
                            placeholder="8자리 일련번호"
                            name="serialNumber"
                            value={formData.serialNumber}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                      <div class="input-item">
                        <p class="input-title">화재수신기 DEI 코드</p>
                        <div class="input-inner-wrap">
                          <input
                            class="defaultInput"
                            type="text"
                            placeholder="16자리 DEI 코드"
                            name="dei"
                            value={formData.dei}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            </div>
            <div class="btmBtnWrap">
              <button
                type="button"
                class="btn btn-grey"
                onClick={() => navigate(-1)}
              >
                취소
              </button>
              <button type="submit" class="btn btn-black btn-add">
                추가
              </button>
            </div>
          </form>
        </section>
      }

      {isNotFound && (
        <div
          class="modal-overlay"
          id="fireItemFailModal"
          style={{ display: "flex" }}
        >
          <div class="modal">
            <div class="modal-icon">
              <img src={modalIcon01} alt="확인" />
            </div>
            <p class="modal-title">
              해당 화재수신기로
              <br />
              등록된 소방대상물이 없습니다.
            </p>
            <p class="modal-desc">
              화재 수신기 일련번호와
              <br />
              화재수신기 DEI코드를 다시 확인해주세요.
            </p>
            <button class="btn btn-black" onClick={() => setIsNotFound(false)}>
              확인
            </button>
          </div>
        </div>
      )}

      {isCompleted && (
        <div
          class="modal-overlay"
          id="fireItemSuccessModal"
          style={{ display: "flex" }}
        >
          <div class="modal">
            <div class="modal-icon">
              <img src={modalIcon02} alt="확인" />
            </div>
            <p class="modal-title">소방 대상물을 등록했습니다.</p>
            <p class="modal-desc">해당 소방 대상물을 확인해보세요.</p>
            <div class="modal-btn-wrap">
              <Link class="btn btn-line line-white" to="/fire-on/">
                메인화면
              </Link>
              <Link
                class="btn btn-line line-black"
                to={`/fire-on/fire-alarm-monitor/${target.id}/`}
                state={{
                  buildingName: target.buildingName,
                }}
              >
                대시보드
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
